import { Picture, VerticalSpacer, theme } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`

export const Content = styled(VerticalSpacer).attrs({
  amount: { small: 24, medium: 32, large: 40 },
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
`

export const BackgroundImage = styled(Picture)`
  background-color: ${theme.colors.PINK_30};
  position: absolute;
  top: 0;
  z-index: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
